export enum ApColumnState {
  Red = -1,
  Yellow = 0,
  Green = 1,
  Grey = 2
}
